import { Routes } from "@angular/router";
import { HomeComponent, GetStartedComponent, TermsComponent, PrivacyComponent, CookiesComponent } from "./components";
import { AboutComponent } from "./components/about/about.component";
import { CompatibilityListComponent } from "./components/compatibility/components/compatibility-list/compatibility-list.component";
import { MediaKitComponent } from "./components/media-kit/media-kit.component";
import { ReforestactionPageComponent } from "./events/reforestaction/components/reforestaction-page/reforestaction-page.component";
import { MarketingComponent } from "./marketing.component";
import { CompatibilityService } from "./components/compatibility/services/compatibility.service";
import { EnvironmentProviders, Provider } from "@angular/core";

const providers: Array<Provider | EnvironmentProviders> = [
  CompatibilityService
]

export const marketingRoutes: Routes = [
  {
    path: '',
    component: MarketingComponent,
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
      },
      {
        path: 'home',
        component: HomeComponent,
        data: { title: 'default.head.title', banner: true },
      },
      {
        path: 'get-started',
        component: GetStartedComponent,
        data: { title: 'getstarted.head.title', banner: true },
      },
      {
        path: 'terms',
        component: TermsComponent,
        data: { title: 'terms.head.title', banner: true },
      },
      {
        path: 'privacy',
        component: PrivacyComponent,
        data: { title: 'privacy.head.title', banner: true },
      },
      {
        path: 'cookies',
        component: CookiesComponent,
        data: { title: 'cookies.head.title', banner: true },
      },
      {
        path: 'media-kit',
        component: MediaKitComponent,
        data: { title: 'mediakit.title', banner: true },
      },
      {
        path: 'about',
        component: AboutComponent,
        data: { title: 'about.head.title', banner: true },
      },
      {
        path: 'events/reforestation',
        component: ReforestactionPageComponent,
        data: { title: 'default.head.title', banner: true },
      },
      {
        path: 'compatibility',
        component: CompatibilityListComponent,
        data: { title: 'default.head.title', banner: true },
      },
    ],
    providers: providers
  },
]